import { DocumentType, TypesDocumentsErrors, TypesDocumentsValues } from './type';

export const getEmptyErrors = (): TypesDocumentsErrors => ({
  type: '',
  validity_until: '',
  issuer: '',
  issue_date: '',
  series: '',
  number: '',
  validity_from: '',
  visa_type: '',
  duration_of_stay: '',
  annotations: '',
});

export const getEmptyValues = (type: DocumentType): TypesDocumentsValues => {
  switch (type) {
    case 'residence_permit':
      return {
        validity_until: '',
        issuer: '',
        issue_date: '',
        series: '',
        number: '',
      };
    case 'visa':
      return {
        validity_from: '',
        validity_until: '',
        visa_type: '',
        series: '',
        number: '',
        duration_of_stay: '',
      };
    case 'migration_card':
      return {
        validity_until: '',
        issue_date: '',
        series: '',
        number: '',
      };
    case 'temporary_residence_permit':
      return {
        issuer: '',
        issue_date: '',
        number: '',
      };
    case 'patent':
      return {
        issuer: '',
        issue_date: '',
        series: '',
        number: '',
      };
    case 'work_permit':
      return {
        annotations: '',
        issue_date: '',
        issuer: '',
        number: '',
        series: '',
      };
    case 'employment_contract':
      return {
        validity_until: '',
        issue_date: '',
        number: '',
      };
    default:
      return {};
  }
};
